import MainMenu from '@/components/foundation/main-menu/MainMenu'
import EventMap from '@/view/event-map/EventMap'

export const EventMapRoute = {
  path: '/event/map/:id',
  name: 'EventMap',
  components: {
    default: EventMap,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Evento',
        link: '/event'
      },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/event/EventMapRoute.js